import { ApiController, NotificationsEndPoint } from 'config';
import {
  DiscountRequestNotification,
  DiscountRequestNotificationParams,
} from 'interfaces';
import { get, patch } from '..';

import {
  listUnreadDiscountDemandNotifications,
  markAllNewDemandRead,
} from './userNotifications';

export function getDiscountRequestNotifications(
  params?: DiscountRequestNotificationParams,
) {
  const parsedParams =
    params &&
    new URLSearchParams(
      Object.entries(params).map(([k, v]) => [k, v.toString()]),
    );

  return get<DiscountRequestNotification[]>({
    url: `/${ApiController.notifications}/${NotificationsEndPoint.discountRequest}/non-received`,
    params: parsedParams,
  });
}

export function getUnreadDiscountRequestNotifications() {
  return listUnreadDiscountDemandNotifications();
}

export async function receiveDiscountRequestNotificationsById(
  notificationIds: number[],
) {
  const params = new URLSearchParams(
    notificationIds.map((v) => ['id', v.toString()]),
  );

  await patch({
    url: `/${ApiController.notifications}/${NotificationsEndPoint.discountRequest}/receive-by-id`,
    params,
  });
}

export async function markNewDemandRead(): Promise<void> {
  return markAllNewDemandRead();
}
